import Vue from "vue";
import VueRouter from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import Muse from "../views/Muse.vue";


Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    alias: "/dashboard",
    name: "dashboard",
    component: Dashboard
  },
  {
    path: "/muse",
    name: "muse",
    component: Muse
  },
];

const router = new VueRouter({
  mode: "history",
  routes
});

export default router;
